import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { AuthListener } from '@npm-client-frontends/shared-components'
import { UserPreferencesProviderWrapper } from '@npm-client-frontends/shared-components'
import RootComponent from '../root.component'
import {
  GlobalContextProvider,
  GlobalContextType,
} from '@npm-client-frontends/global-context'

interface IAppRouterProps {
  globalContext: GlobalContextType
}

const AppRouter: React.FC<IAppRouterProps> = ({ globalContext }) => {
  const [authChecked, setAuthChecked] = useState(false)

  useEffect(() => {
    if (authChecked) {
      const { analytics } = globalContext
      analytics.configurePageViewAutoTrack()
    }
  }, [authChecked])

  return (
    <GlobalContextProvider value={globalContext}>
      <UserPreferencesProviderWrapper>
        <Router>
          <AuthListener setAuthChecked={setAuthChecked} />
          {authChecked && (
            <Routes>
              <Route path="/login" element={<></>} />
              <Route path="*" element={<RootComponent />} />
            </Routes>
          )}
        </Router>
      </UserPreferencesProviderWrapper>
    </GlobalContextProvider>
  )
}

export default AppRouter
